export const HotelPmsScreenAccess = {
  EDIT: 'edit',
  READ: 'read',
  DENY: 'deny',
} as const

export type HotelPmsScreenAccess = (typeof HotelPmsScreenAccess)[keyof typeof HotelPmsScreenAccess]

export type HotelPmsScreenKey =
  | 'settings'
  | 'dashboard'
  | 'reservation'
  | 'customer'
  | 'guest_room'
  | 'sales'
  | 'accounts_receivable'
  | 'cleaning'
  | 'mail_sms'
  | 'report'
  | 'survey'
  | 'operation_log'
  | 'restaurant'

export type HotelPmsOperationKey = 'post_closing_sales_edit' | 'cleaning_global_update'

export type HotelPmsExportKey = 'customer_csv_export' | 'sales_csv_export' | 'cleaning_csv_export'

export type HotelPmsPermissions = {
  screens?: Partial<Record<HotelPmsScreenKey, HotelPmsScreenAccess>> & Record<string, HotelPmsScreenAccess | undefined>
  operations?: Partial<Record<HotelPmsOperationKey, boolean>> & Record<string, boolean | undefined>
  exports?: Partial<Record<HotelPmsExportKey, boolean>> & Record<string, boolean | undefined>
}
